import { View, Text, ScrollView } from "react-native";
import React from "react";
import Header from "../components/Header";
import { Image, Button, Icon } from "@rneui/base";
import { styles } from "../styles/mainStyle";
import Collection from "../components/Collection";
import Toast from "react-native-toast-message";
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase.js";

const HomeVendedor = ({ navigation }) => {
  const showToast = () => {
    console.log("im suposed to be happening");
    Toast.show({
      type: "success",
      text1: "Todavia",
      text2: "ir al perfil",
    });
  };

  const logOut = () => {
    signOut(auth)
      .then(() => {
        navigation.replace("Login");
      })
      .catch((error) => {
        // An error happened.
      });
  };

  const check = () => {
    var requestOptions = {
      method: "POST",
      redirect: "follow",
    };

    fetch(
      "http://sa08.ddns.net:7780/AppAndroid/servlet/ServletAndroid?empresa=drn&usuario=consultaweb&clave=web3007&dato=enviodocumento&documento=<documento><detallePedido><detallepedido><cantidad>1</cantidad><codigo>M-P0020-0</codigo><denominacion>MUSCULOSA CUELLO BOTE DAMA L </denominacion><incluye__iva>N</incluye__iva><iva>21</iva><modprecio>S</modprecio><porbonif>0</porbonif><precio>171.59</precio><precio__con__iva>207.624</precio__con__iva><precio__id>1</precio__id></detallepedido><detallepedido><cantidad>2</cantidad><codigo>X-00001-0</codigo><denominacion>SALSA DE TOMATES S 1000 KI</denominacion><incluye__iva>N</incluye__iva><iva>21</iva><modprecio>S</modprecio><porbonif>0</porbonif><precio>1.19</precio><precio__con__iva>1.44</precio__con__iva><precio__id>1</precio__id></detallepedido></detallePedido><sObservaciones></sObservaciones><sPersona__id>1461</sPersona__id><sPersonaliza></sPersonaliza><sTipo>Presupuesto</sTipo><sTransporte__id>0</sTransporte__id></documento>",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log("error", error));
  };

  const produ = [
    {
      subfamilia: "ARANDELAS VARIAS",
      stock: "0",
      sku: "A-00008-0",
      tipo: "9 - OTROS",
      familia: "A-",
      precio: "20",
      nombre: "ARANDELA SEGURO SACHS 98",
    },
    {
      stock: "181",
      subfamilia: "A-",
      precio: "7.6",
      sku: "A-00010-0",
      familia: "A-",
      nombre: "ARAND. SEGURO EMBRAGUE PUMA 4TA",
      tipo: "9 - OTROS",
    },
    {
      familia: "A-",
      nombre: "ARANDELA COMPENSACION",
      sku: "A-00013-0",
      stock: "0",
      subfamilia: "A-",
      tipo: "9 - OTROS",
      precio: "1.344",
    },
    {
      stock: "0",
      precio: "5.912",
      familia: "A-",
      tipo: "9 - OTROS",
      nombre: "ARANDELA CUBRE RETEN SACHS",
      subfamilia: "A-",
      sku: "A-00014-0",
    },
  ];
  return (
    <ScrollView>
      <Header title={"Vendedor"} />
      <Image
        source={require("../assets/eroban.jpg")}
        style={{
          width: "100vw",
          height: "100vw",
          resizeMode: "contain",
        }}
      />
      <View>
        <Text style={styles.headerTitleBlue}>Bienvenido Vendedor</Text>
      </View>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: 20,
        }}
      >
        <Button
          radius={"sm"}
          type="solid"
          iconRight="true"
          onPress={() => navigation.navigate("StoreAdmin")}
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
        >
          Iniciar Pedido
          <Image
            source={require("../assets/cart-shopping-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button>
        <Button
          radius={"sm"}
          type="solid"
          iconRight="true"
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
          onPress={logOut}
        >
          Pedidos Previos
          <Image
            source={require("../assets/user-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button>
        <Button
          radius={"sm"}
          type="solid"
          iconRight="true"
          buttonStyle={styles.buttonHome}
          titleStyle={styles.btnTitleHome}
          onPress={check}
        >
          Check
          <Image
            source={require("../assets/user-solid.svg")}
            style={{
              width: 20,
              height: 20,
              resizeMode: "contain",
              marginRight: 10,
            }}
          />
        </Button>
      </View>
    </ScrollView>
  );
};

export default HomeVendedor;
